export default class BarebonesWorkAgreementInfoAPIResponse {
  id?: string;
  error?: string;
  name?: string;
  description?: string;
  createdDate?: string;
}
